import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=2f96e5e9&scoped=true"
import script from "./Todos.vue?vue&type=script&lang=js"
export * from "./Todos.vue?vue&type=script&lang=js"
import style0 from "./Todos.vue?vue&type=style&index=0&id=2f96e5e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96e5e9",
  null
  
)

export default component.exports